import { styled } from '@mui/material/styles';

import { InsurersTable } from '../../Components/InsurersTable';

export const InsurersTableStyled = styled(InsurersTable, {
  name: 'InsurersTableStyled',
})(({ theme }) => ({
  marginTop: theme.spacing(1),
}));
